{
    "name": "FI Step Manager",
    "uri": "http://fism",
    "prefix": "fism",
    "xml": {
        "tagAlias": "lowerCase"
    },
    "types": [
        {
            "name": "List",
            "extends": ["bpmn:Process"],
            "properties": [
                {
                    "name": "siteId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "siteName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "siteUrl",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "listId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "listName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "listPath",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "startPriority",
                    "isAttr": true,
                    "type": "Integer"
                },
                {
                    "name": "startWhen",
                    "isAttr": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "Permissions",
            "superClass": ["Element"],
            "properties": [
                {
                    "name": "breakPermissionInheritance",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "maintainExistingPermissions",
                    "isAttr": true,
                    "type": "Boolean"
                },
                {
                    "name": "editorPermissions",
                    "isMany": false,
                    "type": "EditorPermissions"
                },
                {
                    "name": "readerPermissions",
                    "isMany": false,
                    "type": "ReaderPermissions"
                }
            ]
        },
        {
            "name": "EditorPermissions",
            "properties": [
                {
                    "name": "users",
                    "isMany": false,
                    "type": "Users"
                },
                {
                    "name": "groups",
                    "isMany": false,
                    "type": "Groups"
                },
                {
                    "name": "fields",
                    "isMany": false,
                    "type": "Fields"
                }
            ]
        },
        {
            "name": "ReaderPermissions",
            "properties": [
                {
                    "name": "users",
                    "isMany": false,
                    "type": "Users"
                },
                {
                    "name": "groups",
                    "isMany": false,
                    "type": "Groups"
                },
                {
                    "name": "fields",
                    "isMany": false,
                    "type": "Fields"
                }
            ]
        },
        {
            "name": "Users",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "Principal"
                }
            ]
        },
        {
            "name": "Groups",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "Principal"
                }
            ]
        },
        {
            "name": "Principal",
            "properties": [
                {
                    "name": "name",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "loginName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "email",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "id",
                    "isAttr": true,
                    "type": "Integer"
                }
            ]
        },
        {
            "name": "Fields",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "Field"
                }
            ]
        },
        {
            "name": "Field",
            "properties": [
                {
                    "name": "displayName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "internalName",
                    "isAttr": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListActions",
            "superClass": ["Element"],
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "ListAction"
                }
            ]
        },
        {
            "name": "ListAction",
            "properties": [
                {
                    "name": "id",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "name",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "action",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "source",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sourceSubSiteId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sourceSubSiteName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sourceSubSiteUrl",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sourceListId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sourceListName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "target",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "targetSubSiteId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "targetSubSiteName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "targetSubSiteUrl",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "targetListId",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "targetListName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "executeOn",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "filter",
                    "isMany": false,
                    "type": "ListFilter"
                },
                {
                    "name": "select",
                    "isMany": false,
                    "type": "ListSelect"
                },
                {
                    "name": "expand",
                    "isMany": false,
                    "type": "ListExpand"
                },
                {
                    "name": "field",
                    "isMany": false,
                    "type": "ListField"
                },
                {
                    "name": "item",
                    "isMany": false,
                    "type": "ListItem"
                },
                {
                    "name": "variableName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "includeVersions",
                    "isAttr": true,
                    "type": "Boolean"
                },
                {
                    "name": "numberOfVersions",
                    "isAttr": true,
                    "type": "Integer"
                },
                {
                    "name": "processDefinitionKey",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "processDefinitionName",
                    "isAttr": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListFilter",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListSelect",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListExpand",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListField",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "ListItem",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "Mails",
            "superClass": ["Element"],
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "Mail"
                }
            ]
        },
        {
            "name": "Mail",
            "properties": [
                {
                    "name": "id",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "name",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "from",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "replyTo",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "sendto",
                    "isMany": false,
                    "type": "MailSendTo"
                },
                {
                    "name": "sendtofield",
                    "isMany": false,
                    "type": "MailSendToFields"
                },
                {
                    "name": "copyto",
                    "isMany": false,
                    "type": "MailCopyTo"
                },
                {
                    "name": "copytofield",
                    "isMany": false,
                    "type": "MailCopyToFields"
                },
                {
                    "name": "subject",
                    "isMany": false,
                    "type": "MailSubject"
                },
                {
                    "name": "body",
                    "isMany": false,
                    "type": "MailBody"
                },
                {
                    "name": "documentation",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "executeOn",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "active",
                    "isAttr": true,
                    "type": "Boolean"
                }
            ]
        },
        {
            "name": "MailSendTo",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "MailRecipient"
                }
            ]
        },
        {
            "name": "MailSendToFields",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "MailRecipientField"
                }
            ]
        },
        {
            "name": "MailCopyTo",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "MailRecipient"
                }
            ]
        },
        {
            "name": "MailCopyToFields",
            "properties": [
                {
                    "name": "values",
                    "isMany": true,
                    "type": "MailRecipientField"
                }
            ]
        },
        {
            "name": "MailRecipient",
            "properties": [
                {
                    "name": "name",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "loginName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "email",
                    "isAttr": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "MailRecipientField",
            "properties": [
                {
                    "name": "displayName",
                    "isAttr": true,
                    "type": "String"
                },
                {
                    "name": "internalName",
                    "isAttr": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "MailSubject",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        },
        {
            "name": "MailBody",
            "properties": [
                {
                    "name": "value",
                    "isBody": true,
                    "type": "String"
                }
            ]
        }
    ]
}
